/* lr-vorbelegen.js – Textfelder im teeinblue-Gestalter mit dem Beispieltext vorbelegen (29.09.2026, Luca:
   "was auf dem Poster steht, soll schon im Feld stehen, man überschreibt es nur").
   Quelle der Texte: die Kampagnendaten, die teeinblue selbst lädt (gleiche Adresse -> Browser-Cache).
   Gefüllt wird nur ein LEERES Feld, das der Kunde noch nicht angefasst hat; nie das Feld mit dem Fokus.
   Eigene Datei, fasst lr-gestalter8.js nicht an.
   30.09.2026: Fehler aus Musterbestellung #1001 behoben - teeinblue zeigt bei LEEREN Feldern den Beispieltext
   in der Vorschau, druckt aber nichts. Deshalb: (1) auch curve-text/paragraph vorbelegen, (2) direkt vor
   "In den Warenkorb" jedes unberuehrte leere Feld synchron nachfuellen, (3) Kampagnendaten sofort laden.
   30.09.2026 (zentrale Konfiguration, Freigabe Luca): Ist window.LoreliaKonfig aktiv (Testschalter lr-neu=1 bzw.
   data-scharf="1"), werden Felder mit persönlicher Rolle (Namen, Ort, Datum, Initialen, Gravur …) NICHT mehr mit dem
   Beispiel befüllt – das Beispiel bleibt als Platzhalter und in der Vorschau sichtbar, lr-konfig.js verlangt die eigene
   Angabe. Alle anderen Felder (z. B. Titel) wie bisher. Ohne aktive Konfiguration: exakt das alte Verhalten. */
(function () {
  var C = window.teeinblueCampaign;
  if (!C || !C.isTeeInBlueProduct || !window.Shopify || !Shopify.shop) return;
  var D = document, texte = null, angefasst = {}, geplant = 0;
  var TITEL_AUTO = 'lr7-titel-auto';
  var TYPEN = ['text', 'curve-text', 'paragraph', 'warp-text', 'shape-text'];

  /* Zentrale Konfiguration nur, wenn sie aktiv ist; sonst null -> altes Verhalten */
  function konfig() { var K = window.LoreliaKonfig; return K && K.aktiv ? K : null; }

  function laden() {
    var u = 'https://api.teeinblue.com/api/merchant/campaigns/' + C.productId + '.json?shop=' + encodeURIComponent(Shopify.shop) + '&v=' + C.version;
    return fetch(u, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (d) {
      texte = {};
      (d.artworks || []).forEach(function (a) {
        (a.data || []).forEach(function (t) {
          (t.layers || []).forEach(function (l) {
            if (l && TYPEN.indexOf(l.type) > -1 && l.customization_type === 'normal' && typeof l.text === 'string' && l.text.trim()) texte[l.id] = l.text;
          });
        });
      });
    });
  }

  function setzeWert(i, v) {
    var proto = i.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(i, v);
    i.dispatchEvent(new Event('input', { bubbles: true }));
    i.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function istTitel(i) {
    var f = i.closest('.tee-field'), h = f && f.querySelector('.tee-field__heading');
    return !!h && /^(titel|title|überschrift)/.test(h.textContent.replace('*', '').trim().toLowerCase());
  }

  function fuellen() {
    geplant = 0;
    if (!texte) return;
    var K = konfig();
    /* Konfiguration aktiv, aber noch nicht geladen: nicht raten, nach dem Laden erneut */
    if (K && !K.geladen) { K.bereit.then(planen, function () {}); if (!K.ladefehler) return; K = null; }
    var felder = D.querySelectorAll('.tee-form-wrapper input[name^="layer-"], .tee-form-wrapper textarea[name^="layer-"]');
    for (var k = 0; k < felder.length; k++) {
      var i = felder[k], id = i.name, v = texte[id];
      if (v == null || i.value || angefasst[id] || i === D.activeElement) continue;
      if (i.tagName === 'INPUT' && i.type !== 'text') continue;
      if (K && K.nichtVorbelegen(C.productId, id)) continue;   /* persönliche Angabe: Beispiel bleibt nur Platzhalter/Vorschau */
      if (i.maxLength > 0 && v.length > i.maxLength) v = v.slice(0, i.maxLength);
      setzeWert(i, v);
      /* Stadtkarten: vorbelegter Titel darf weiter automatisch durch den Ortsnamen ersetzt werden */
      if (istTitel(i)) { try { if (!sessionStorage.getItem(TITEL_AUTO)) sessionStorage.setItem(TITEL_AUTO, v); } catch (e) {} }
    }
  }

  function planen() { if (!geplant) geplant = setTimeout(fuellen, 250); }

  /* Sicherheitsnetz vor dem Warenkorb: teeinblue liest den Formularstand beim Klick. Deshalb in der
     Capture-Phase VOR teeinblue synchron fuellen (Vue uebernimmt input-Events sofort). */
  function vorWarenkorb(e) {
    var b = e.target && e.target.closest && e.target.closest('button, [role="button"], a');
    if (!b) return;
    /* alle Warenkorb-Knoepfe: teeinblue (.tee-btn--atc), Horizon (.add-to-cart-button, auch klebend) und eigene */
    if (!b.matches('.tee-btn--atc, .add-to-cart-button, button[name="add"]') && !/warenkorb|add to cart/i.test(b.textContent || '')) return;
    if (geplant) { clearTimeout(geplant); geplant = 0; }
    fuellen();
  }
  D.addEventListener('click', vorWarenkorb, true);
  D.addEventListener('submit', function () { if (geplant) { clearTimeout(geplant); geplant = 0; } fuellen(); }, true);

  /* Kunde tippt oder löscht selbst -> dieses Feld nie wieder automatisch füllen */
  D.addEventListener('input', function (e) {
    var t = e.target;
    if (e.isTrusted && t && t.name && /^layer-/.test(t.name)) angefasst[t.name] = true;
  }, true);

  /* lr-konfig.js ruft das vor seiner Prüfung auf (gleiche Regeln wie der eigene Warenkorb-Abfang) */
  window.LoreliaVorbelegen = { fuellen: function () { if (geplant) { clearTimeout(geplant); geplant = 0; } fuellen(); } };

  laden().then(function () {
    planen();
    /* teeinblue (Vue) baut die Felder bei Vorlagen-, Rahmen- und Größenwechsel neu -> nachfüllen */
    var ziel = D.querySelector('.tee-campaign') || D.body;
    new MutationObserver(planen).observe(ziel, { childList: true, subtree: true });
    D.addEventListener('focusout', planen, true);
  }).catch(function () {});
})();
